import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import formatDropdownData from "../../utils/formatDropdownData";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

export const fetchPublicCategories = async (lng = "english", params) => {
  const { listType } = params || {};
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    const options = {
      method: "GET",
      url: `${api("profile")}/public/account/categories`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "name", "id");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_business_categories);
  }
};

export const fetchBusinessCategories = async (lng = "english", params) => {
  const { listType, id } = params || {};
  const { accessToken } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("profile")}/business/categories`,
      data: null, //force axios send headers content type
      params: {
        id,
      },
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "name", "id");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_business_categories);
  }
};
